import { useChannelTalk } from '@repo/channel-talk';
import { Description } from '@zenterprise-inc/ui';
import { FC, useMemo } from 'react';

import IllustChat from '@/assets/illust-icons/fill-balloon-chat-more-gy2.svg';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

interface Props {
  outStatCd: string;
}
type TrpSuccessContentProps = Props;

const TrpSuccessContent: FC<TrpSuccessContentProps> = ({ outStatCd }) => {
  const { openChannelTalk } = useChannelTalk();

  const content = useMemo(() => {
    switch (outStatCd) {
      case '0031':
        return (
          <Description.Guide
            subTitle="결제 요청 중 문제가 발생했어요"
            description={'동일한 문제가 반복된다면\n고객센터로 문의해주세요.'}
            imgChild={<IllustChat width={80} height={80} />}
            button={{
              state: 'basic',
              onClick: () => {
                openChannelTalk(SUPPORT_BOT_LINK.errors);
              }
            }}
            buttonContent={'문의하기'}
          />
        );

      default:
        return (
          <Description.Guide
            imgChild={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_check_sm.svg`} className={'w-20'} alt={''} />}
            subTitle="카드 결제가 완료되었어요!"
            description={'비즈넵을 이용해주셔서 감사합니다.'}
          />
        );
    }
  }, [openChannelTalk, outStatCd]);

  return <div className="flex h-[calc(100vh-100px)] grow items-center">{content}</div>;
};

export default TrpSuccessContent;
